import React from 'react';
import { 
  FaPlay, 
  FaFileAlt, 
  FaBook, 
  FaPuzzlePiece,
  FaComments,
  FaVideo,
  FaUsers,
  FaNetworkWired,
  FaGraduationCap,
  FaBullseye,
  FaHandshake
} from 'react-icons/fa';

function QuemSomos() {
  const oferecemos = [
    {
      icon: <FaPlay />,
      title: "Videoaulas Exclusivas",
      description: "Resolução detalhada de exercícios e Atividades Avaliativas"
    },
    {
      icon: <FaFileAlt />,
      title: "Provas Resolvidas",
      description: "Explicações passo a passo para seu entendimento"
    },
    {
      icon: <FaBook />,
      title: "Resumos Estratégicos",
      description: "Principais conteúdos organizados de forma otimizada"
    },
    {
      icon: <FaPuzzlePiece />,
      title: "Materiais Complementares",
      description: "Desenvolvidos especialmente para sua jornada"
    }
  ];

  const redeApoio = [
    {
      icon: <FaComments />,
      title: "Troque Experiências",
      description: "Compartilhe dúvidas e experiências com colegas"
    },
    {
      icon: <FaVideo />,
      title: "Compartilhe Materiais",
      description: "PDFs e vídeos do YouTube com a comunidade"
    },
    {
      icon: <FaUsers />,
      title: "Participe de Discussões",
      description: "Enriqueça seu aprendizado com debates construtivos"
    },
    {
      icon: <FaNetworkWired />,
      title: "Construa sua Rede",
      description: "Contatos que vão além da graduação"
    }
  ];

  return (
    <div style={{ 
      flex: 1, 
      overflowY: 'auto', 
      background: '#ffffff',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif"
    }}>
      {/* Header Section */}
      <section style={{
        background: 'linear-gradient(135deg, #172033 0%, #3293D4 100%)',
        color: 'white',
        textAlign: 'center',
        padding: '4rem 2rem',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          opacity: 0.5
        }}></div>
        <div style={{ position: 'relative', zIndex: 2, maxWidth: '800px', margin: '0 auto' }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: '800',
            marginBottom: '0.5rem',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
          }}>
            EAD Conect
          </h1>
          <p style={{
            fontSize: '1.2rem',
            opacity: 0.9,
            fontWeight: '500'
          }}>
            A Rede Social dos alunos da Univesp!
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section style={{ padding: '4rem 2rem', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '3rem',
          boxShadow: '0 10px 40px rgba(23,32,51,0.1)',
          marginBottom: '4rem',
          border: '1px solid #f1f5f9'
        }}>
          <p style={{
            fontSize: '1.2rem',
            lineHeight: '1.8',
            color: '#64748b',
            textAlign: 'center',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            A EAD Conect é mais que uma plataforma de ensino — é uma{' '}
            <span style={{ color: '#3293D4', fontWeight: '600' }}>
              comunidade criada por quem entende suas necessidades
            </span>. Fundada por ex-alunos da Univesp e por professores com larga 
            experiência no ensino a distância, nossa missão é transformar desafios em conquistas através 
            de um ecossistema completo de apoio acadêmico.
          </p>
        </div>

        {/* O que oferecemos */}
        <div style={{ marginBottom: '5rem' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
            marginBottom: '3rem'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #3293D4 0%, #172033 100%)',
              borderRadius: '50%',
              padding: '0.75rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <FaBullseye style={{ fontSize: '1.5rem', color: 'white' }} />
            </div>
            <h2 style={{
              fontSize: '2rem',
              fontWeight: '700',
              color: '#172033',
              margin: 0
            }}>
              O que oferecemos
            </h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem'
          }}>
            {oferecemos.map((item, index) => (
              <div key={index} style={{
                background: 'white',
                padding: '2.5rem 2rem',
                borderRadius: '16px',
                textAlign: 'center',
                boxShadow: '0 8px 25px rgba(23,32,51,0.08)',
                border: '1px solid #f1f5f9',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 15px 40px rgba(50,147,212,0.15)';
                e.currentTarget.style.borderColor = '#3293D4';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(23,32,51,0.08)';
                e.currentTarget.style.borderColor = '#f1f5f9';
              }}>
                <div style={{
                  fontSize: '2.5rem',
                  color: '#3293D4',
                  marginBottom: '1.5rem',
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                  {item.icon}
                </div>
                <h3 style={{
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  color: '#172033',
                  marginBottom: '1rem'
                }}>
                  {item.title}
                </h3>
                <p style={{
                  color: '#64748b',
                  lineHeight: '1.6',
                  fontSize: '0.95rem'
                }}>
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Rede de apoio acadêmico */}
        <div style={{
          background: 'linear-gradient(135deg, #172033 0%, #3293D4 100%)',
          borderRadius: '24px',
          padding: '4rem 3rem',
          color: 'white',
          marginBottom: '4rem',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
            opacity: 0.3
          }}></div>
          
          <div style={{ position: 'relative', zIndex: 2 }}>
            <div style={{
              textAlign: 'center',
              marginBottom: '3rem'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '1rem',
                marginBottom: '1rem'
              }}>
                <div style={{
                  background: '#FFE00C',
                  borderRadius: '50%',
                  padding: '0.75rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <FaHandshake style={{ fontSize: '1.5rem', color: '#172033' }} />
                </div>
                <h2 style={{
                  fontSize: '2rem',
                  fontWeight: '700',
                  margin: 0
                }}>
                  Sua rede de apoio acadêmico
                </h2>
              </div>
              <p style={{
                fontSize: '1.1rem',
                opacity: 0.9,
                maxWidth: '600px',
                margin: '0 auto',
                lineHeight: '1.6'
              }}>
                Conecte-se com estudantes de todos os polos em um ambiente colaborativo onde você pode:
              </p>
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: '2rem'
            }}>
              {redeApoio.map((item, index) => (
                <div key={index} style={{
                  background: 'rgba(255,255,255,0.15)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '16px',
                  padding: '2rem 1.5rem',
                  textAlign: 'center',
                  transition: 'transform 0.3s ease, background 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                }}>
                  <div style={{
                    fontSize: '2rem',
                    color: '#FFE00C',
                    marginBottom: '1rem',
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                    {item.icon}
                  </div>
                  <h3 style={{
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    marginBottom: '0.75rem'
                  }}>
                    {item.title}
                  </h3>
                  <p style={{
                    opacity: 0.9,
                    lineHeight: '1.5',
                    fontSize: '0.9rem'
                  }}>
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Call to Action Final */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '3rem',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(23,32,51,0.1)',
          border: '1px solid #f1f5f9'
        }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#172033',
            marginBottom: '1rem'
          }}>
            Na EAD Conect, você não estuda sozinho
          </h2>
          <p style={{
            fontSize: '1.2rem',
            color: '#64748b',
            marginBottom: '2.5rem',
            lineHeight: '1.6'
          }}>
            Você faz parte de uma comunidade que cresce junto.
          </p>
          <button 
            onClick={() => window.location.href = '/cadastro'}
            style={{
              background: 'linear-gradient(135deg, #3293D4 0%, #172033 100%)',
              color: 'white',
              border: 'none',
              padding: '1rem 2.5rem',
              borderRadius: '50px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.75rem',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 25px rgba(50,147,212,0.3)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 12px 35px rgba(50,147,212,0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(50,147,212,0.3)';
            }}
          >
            <FaGraduationCap />
            Junte-se à Comunidade
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        background: '#172033',
        color: 'white',
        textAlign: 'center',
        padding: '3rem 2rem',
        marginTop: '2rem'
      }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h3 style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            marginBottom: '1rem'
          }}>
            EAD Conect
          </h3>
          <p style={{
            opacity: 0.8,
            lineHeight: '1.6'
          }}>
            Transformando desafios em conquistas através da educação colaborativa
          </p>
        </div>
      </footer>
    </div>
  );
}

export default QuemSomos;